import { render, staticRenderFns } from "./FeaturesEvents.vue?vue&type=template&id=74b0beb5&scoped=true"
import script from "./FeaturesEvents.vue?vue&type=script&lang=js"
export * from "./FeaturesEvents.vue?vue&type=script&lang=js"
import style0 from "./FeaturesEvents.vue?vue&type=style&index=0&id=74b0beb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0beb5",
  null
  
)

export default component.exports